<div :id="$vId(this)" :class="$style.slider">
  <!-- content -->
  <div :class="$style.sliderZone">
    <div ref="content" :class="$style.sliderContent">
      <slot></slot>
    </div>
  </div>
  <!-- click: back -->
  <transition name="fade">
    <div :class="$style.sliderPrev" v-if="canPrev()">
      <button
        type="button"
        :class="$style.sliderPrevIcon"
        @click="slideMove('prev')">
      </button>
    </div>
  </transition>
  <!-- click: next -->
  <transition name="fade">
    <div :class="$style.sliderNext" v-if="canNext()">
      <button
        type="button"
        :class="$style.sliderNextIcon"
        @click="slideMove('next')">
      </button>
    </div>
  </transition>
</div>
